import { render, staticRenderFns } from "./autoplay-item.vue?vue&type=template&id=68d3f7ea&scoped=true&"
import script from "./autoplay-item.vue?vue&type=script&lang=ts&"
export * from "./autoplay-item.vue?vue&type=script&lang=ts&"
import style0 from "./autoplay-item.vue?vue&type=style&index=0&id=68d3f7ea&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68d3f7ea",
  null
  
)

export default component.exports